import React       from 'react';
import ReactDom    from 'react-dom';
// -------------------------------------------------------

class InputSelect extends React.Component {
  update() {
    this.props.update_ev.bind(this)(this.item.value);
  }
  
  render() {
    let data = this.props.data;
    
    return (
      <div className="selectbox">
        <select ref={(input) => { this.item = input }} onChange={this.update.bind(this)} defaultValue={data.default}>
          { data.list.map((d, key) => {
            return <option key={key} value={d.id}>{d.name}</option>
           })}
        </select>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputSelect;